//import dependencies (styles, components, scripts)
import '../styles/output.css'
import Layout from './Layout'
import Header from './Header'
import About from './About'
import Services from './Services'
import Works from './Work'
import Skills from './Skills'
import Contacts from './Contacts'
//Return the App component which contains all sections
let App=()=>{
    return(
      <Layout>
        <Header/>
        <About/>
        <Works/>
        <Services/>
        <Skills/>
        <Contacts/>
      </Layout>
    )
}
export default App